import React from "react";

const ModalButton = ({ onClick, type = "flat", text }) => {
  let className =
    type === "flat" ? "h-10 text-black-700 rounded-lg px-2 dark:text-black-400" : "h-10 text-white rounded-lg px-2 hover:opacity-70 transition-all ";
  if (type === "primary") className += "bg-blue";
  if (type === "danger") className += "bg-red";
  if (type === "success") className += "bg-green";

  return (
    <button className={className} onClick={onClick}>
      {text}
    </button>
  );
};

export default ModalButton;
